module.exports = __webpack_public_path__ + "img/payment_bg.e0f39e29.png";